import {Message} from '@gongxigames/framework/slot/types/Message';

export const StoppedDueToInsufficientFunds: Message = {
    id: 'StoppedDueToInsufficientFunds',
    type: 'normal',
    title: {id: 'autoplayStopped'},
    message: {id: 'insufficientFunds'},
    buttons: [
        {title: {id: 'ok'}, action: 'close_message'},
        {title: {id: 'deposit'}, action: 'deposit'}
    ]
};

export const StoppedDueToLossLimitReached: Message = {
    id: 'StoppedDueToLossLimitReached',
    type: 'normal',
    title: {id: 'autoplayStopped'},
    message: {id: 'lossLimitReached'},
    closeButton: true
};

export const StoppedDueToWinLimitReached: Message = {
    id: 'StoppedDueToWinLimitReached',
    type: 'normal',
    title: {id: 'autoplayStopped'},
    message: {id: 'winLimitReached'},
    closeButton: true
};

export const StoppedDueToSingleWinReached: Message = {
    id: 'StoppedDueToSingleWinReached',
    type: 'normal',
    title: {id: 'autoplayStopped'},
    message: {id: 'singleWinReached'},
    closeButton: true
};
